import { useState } from 'react';

import { Box, Typography, IconButton } from '@mui/material';

import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import TopicIcon from '@mui/icons-material/Topic';

import Youtube, { YouTubeEvent } from 'react-youtube';

const ContentPlayer = ({ level, link, onStateChange }: {
  level: string,
  link: string,
  onStateChange: (event: YouTubeEvent) => void,
}) => {

  const no_content = (
    <Box sx={{
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      height: '100%', bgcolor: 'rgb(200, 200, 200)'
    }}>
      <Typography variant='subtitle1' sx={{ textAlign: 'center' }}>
        沒有內容
      </Typography>
    </Box>
  );

  const [clickedPlay, setClickedPlay] = useState<boolean>(false);
  const [thumbIndex, setThumbIndex] = useState(0); // for trying different thumbnail resolutions

  // console.log('link', link);
  if (!link) { // catch '', undefined, null
    return no_content;
  } else if (link.includes('quickconnect.to/vs')) {
    return (
      <Box sx={(theme) => ({
        display: 'block', position: 'relative', cursor: 'pointer', width: '100%', height: '100%',
        bgcolor: level === 'Y' ? theme.palette.secondary.main :
          level === 'R' ? theme.palette.error.main : theme.palette.primary.light,
      })}
        component='a'
        href={link}
        target='_blank'
      >
        <Typography variant='h4' sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'black'
        }}>
          Synology
        </Typography>
        <IconButton sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'rgba(0,0,0,0.5)',
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.7)',
          }
        }}><PlayCircleOutlineIcon sx={{ width: 48, height: 48, }} /></IconButton>
      </Box>
    )
  } else if (link.includes('youtube.com') || link.includes('https://youtu.be/')) {
    const match = link.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([^&?/]+)/);
    // console.log(match);
    let videoId = match?.[1].trim();
    // console.log('videoId', videoId);

    if (!clickedPlay) {
      const srcList = [ // some might not have higher resolution thumbnails
        `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
        `https://img.youtube.com/vi/${videoId}/sddefault.jpg`,
        `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
        `https://img.youtube.com/vi/${videoId}/default.jpg`,
      ];

      return (
        <Box sx={{ position: 'relative', cursor: 'pointer', width: '100%', height: '100%' }}
          onClick={() => setClickedPlay(true)}
        >
          <Box
            component='img'
            src={srcList[thumbIndex]}
            sx={{
              width: '100%',
              aspectRatio: '16 / 8',
              height: '100%',
              // objectFit: 'contain',  // prevent distortion
              objectFit: 'cover',  // prevent distortion
              backgroundColor: 'black', // black bars
              borderRadius: 1,
              display: 'block', // default uses inline-block which adds extra space below
            }}
            onLoad={(e) => {
              const img = e.target as HTMLImageElement;
              // If YouTube gives you a fake tiny image, fallback to other resolutions
              if (img.naturalWidth <= 120) {
                if (thumbIndex < srcList.length - 1) {
                  setThumbIndex(thumbIndex + 1);
                }
              }
            }}
          />
          <IconButton sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(0,0,0,0.5)',
            color: 'white',
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.7)',
            }
          }}><PlayCircleOutlineIcon sx={{ width: 48, height: 48, }} /></IconButton>
        </Box>
      );
    } else {
      return (
        <Youtube
          videoId={videoId}
          onStateChange={onStateChange}
          opts={{
            height: '100%', width: '100%', playerVars: { autoplay: 1, },
          }}
          style={{ height: '100%' }}
        />
      );
    }
  } else if (link.includes('quickconnect.to/d')) {
    return (
      <Box sx={(theme) => ({
        display: 'block', position: 'relative', cursor: 'pointer', width: '100%', height: '100%',
        bgcolor: level === 'Y' ? theme.palette.secondary.main :
          level === 'R' ? theme.palette.error.main : theme.palette.primary.light,
      })}
        component='a'
        href={link}
        target='_blank'
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'white',
        }}>
          <TopicIcon
            sx={{ width: 48, height: 48, }}
          />
          <Typography variant='body1' textAlign='center'>PDF</Typography>
        </Box>
      </Box>
    )
  } else { // link is not in the above format
    return no_content;
  }
}

export default ContentPlayer;